import { ConfigProvider, theme } from "antd";
import { Foreground } from "./Foreground/Foreground";
import "./App.css";

function App() {
  const { darkAlgorithm } = theme;
  return (
    <ConfigProvider
      theme={{
        algorithm: darkAlgorithm,
        token: {
          colorPrimary: "#f6b34b",
          colorBgBase: "#1f1e23",
          colorBgContainer: "#1f1e23",
          colorText: "#ffffff",
          colorTextHeading: "#ffffff",
          colorTextSecondary: "#cccccc",
        },
        components: {
          Button: {
            colorPrimary: "#F6B34B",
            colorPrimaryHover: "#ffca72",
            colorPrimaryActive: "#d99b3f",
            colorTextLightSolid: "#1f1e23",
            colorText: "#ffffff",
            colorPrimaryText: "#F6B34B",
            colorPrimaryTextHover: "#ffca72",
            colorPrimaryTextActive: "#d99b3f",
            colorTextLabel: "#ffffff",
          },
          Input: {
            colorText: "#ffffff",
            colorBgContainer: "#1f1e23",
            colorPrimary: "#F6B34B",
            colorPrimaryHover: "#ffca72",
            colorPrimaryActive: "#d99b3f",
            colorBorder: "#6e6d74",
            colorPrimaryBorderHover: "#F6B34B",
            colorPrimaryBorder: "#6e6d74",
            colorBgBase: "#1f1e23",
            colorTextPlaceholder: "#6e6d74",
            colorTextSecondary: "#6e6d74",
            colorTextBase: "#ffffff",
            colorFill: "#1f1e23",
          },
        },
      }}
    >
      <div className="h-full w-full">
        <Foreground />
      </div>
    </ConfigProvider>
  );
}

export default App;
